<template>
	<div>
		<div class="logo">
			<!--<router-link to="/"><img src="@/static/img/admin_logo.png" width="180" style="padding:20px 10px" alt=""></router-link>-->
			<!--<div style="font-size:30px;text-align: center;color:white;padding:20px;border-bottom: 1px solid #666666;"><span>YC</span>CMS</div>-->
		</div>

		<el-menu class="navbar" :default-openeds="aaa" background-color="#283846" text-color="#a7b1c2" active-text-color="#fff">
			<div v-for="(item,index) in router" :key="index" v-if="item.hidden!=true">
				<el-submenu :index="''+index+''" v-if="item.children==undefined ||item.children.length>=1">
					<template slot="title">
						<i :class="'el-icon-'+item.meta.icon"></i>
						<span> {{item.title}}</span>
					</template>
					<el-menu-item-group>
						<router-link :to="{path:item.path+item2.path,query: item2.params}"
							v-for="(item2,index2) in item.children" :key="index2"
							v-if="item2.hidden!=true && item2.params!=undefined">
							<el-menu-item :index="index+'-'+index2+''">{{item2.title}}</el-menu-item>
						</router-link>
						<router-link :to="{path:item.path+item2.path}" v-else-if="item2.hidden!=true">
							<el-menu-item :index="index+'-'+index2+''">{{item2.title}}</el-menu-item>
						</router-link>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item :index="''+index+''" v-else>
					<i :class="'el-icon-'+item.meta.icon"></i>
					<span slot="title">
						<router-link :to="item.children[0].path">{{item.title}}</router-link>
					</span>
				</el-menu-item>
			</div>
		</el-menu>
	</div>
</template>

<script>
	import storage from 'good-storage'
	import {
		asyncRoutes
	} from '@/router'
	import {
		getToken
	} from '@/tool/cookie'
	export default {
		name: "SideNav",
		data() {
			return {
				router: null,
				aaa:[],
				// router_matched:this.$route.matched,
				// publicPath: process.env.BASE_URL
			}
		},
		mounted() {
			// let login_uid = getToken('login_uid');
			let login_uid = 1;
			// 判断是否是超级管理员
			if (login_uid == 1) {
				this.router = asyncRoutes;
			} else {
				// this.router = JSON.parse(getToken('manager_role'));
				this.router = JSON.parse(storage.get('manager_role'));
			}
			// this.router=this.$router.options.routes
			// this.router_matched=this.$route.matched
			// console.log(this.router)
		},
	}
</script>

<style scoped>

</style>
